// Compare to ../ServerRouterApp.jsx
import React from 'react';
import { Provider } from 'react-redux';
import Loadable from 'react-loadable';

import finalCreateStore from '../store/organizationConfigStore';
import Loading from 'lib/components/Loading'; // eslint-disable-line

const NotificationBadgeContainer = Loadable({
  loader: () =>
    import('../containers/NotificationBadge/NotificationBadgeContainer'),
  loading: Loading,
});

export default props => {
  const store = finalCreateStore(props);
  return (
    <Provider store={store}>
      <NotificationBadgeContainer />
    </Provider>
  );
};
